<template>
  <div>
    <el-drawer
      ref="drawer"
      :append-to-body="true"
      :title="titleName"
      :visible.sync="newSiteDrawer"
      direction="ltr"
      size="70%"
      @close="cancelForm"
    >
      <div style="padding: 0 20px; height: calc(100vh - 67px); overflow: auto">
        <el-form
          ref="addForm"
          :label-position="$i18n.locale != 'zh' ? 'top' : 'right'"
          :model="ruleForm"
          :rules="rules"
          class="demo-ruleForm"
          size="small"
        >
          <el-row :gutter="20">
            <el-card shadow="never" class="cardClass">
              <div class="title_top_class">
                <!-- 网点基础信息 -->
                {{ $t('collectionCenter.branchBasicInfo') }}
              </div>
              <el-col :span="8">
                <!-- 网点编号 -->
                <el-form-item :label="$t('collectionCenter.siteNum')" prop="code">
                  <el-input
                    v-if="isModify"
                    v-model.trim="ruleForm.code"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                    style="width: 100%"
                  />
                  <span v-else class="nameCode-class">{{ ruleForm.code || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 网点名称： -->
                <el-form-item :label="$t('collectionCenter.siteName')" prop="name">
                  <el-input
                    v-if="isModify"
                    v-model.trim="ruleForm.name"
                    :maxlength="100"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                    show-word-limit
                    :rows="1"
                  />
                  <span v-else class="nameCode-class">{{ ruleForm.name || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 经营模式 -->
                <el-form-item :label="$t('collectionCenter.businessModel')" prop="businessModel">
                  <el-select
                    v-if="isModify"
                    v-model="ruleForm.businessModel"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    clearable
                    filterable
                    style="width: 100%"
                    @change="changeBusinessModel"
                  >
                    <!--  providerId：供应商新增网点  isAll：根据业务主体限制经营模式  -->
                    <el-option
                      v-show="isAll === 1 || isAll === 0"
                      :value="1" :label="$t('collectionCenter.directSales')"
                    /><!--  直营  -->
                    <el-option
                      v-show="isAll === 2 || isAll === 0"
                      :value="2" :label="$t('collectionCenter.joinSales')"
                    /><!--  加盟  -->
                    <el-option
                      :value="3" :label="$t('collectionCenter.exclusive')"
                    /><!--  独家  -->
                  </el-select>
                  <span v-else class="nameCode-class">{{ businessModelLabel }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 网点类型 -->
                <el-form-item :label="$t('collectionCenter.dotTypeCode')" prop="siteType">
                  <el-select
                    v-if="isModify"
                    v-model="ruleForm.siteType"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    clearable
                    filterable
                    style="width: 100%"
                    @change="changeSiteType"
                  >
                    <el-option :label="$t('collectionCenter.hut')" :value="1" /><!-- 小屋 -->
                    <el-option :label="$t('collectionCenter.dot')" :value="2" /><!-- 网点 -->
                    <el-option
                      v-show="ruleForm.businessModel != 2"
                      :label="$t('collectionCenter.transferCenter')"
                      :value="3"
                    /><!-- 转运中心 -->
                    <el-option
                      v-show="ruleForm.businessModel != 2"
                      :label="$t('collectionCenter.headOffice')"
                      :value="4"
                    /><!-- 总部 -->
                  </el-select>
                  <span v-else style="display: inline-block; width: 100%;pointer-events: none">
                    <el-button
                      type="primary" size="small" plain
                      style="color: #424242"
                    >{{ siteTypeLabel }}</el-button>
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 业务类型 -->
                <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">
                  <el-select
                    v-if="isModify"
                    v-model="ruleForm.businessType"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    clearable
                    collapse-tags
                    filterable
                    multiple
                    style="width: 100%"
                    @change="changeBusinessType"
                  >
                    <!-- 转运 -->
                    <el-option
                      v-show="![1, 2, 5].includes(ruleForm.siteType)"
                      :label="$t('collectionCenter.turnTransport')"
                      :value="1"
                    />
                    <!-- 小件揽收 -->
                    <el-option
                      v-show="ruleForm.siteType != 3"
                      :label="$t('collectionCenter.smallCollect')"
                      :value="2"
                    />
                    <!-- 小件派送 -->
                    <el-option
                      v-show="ruleForm.siteType != 3"
                      :label="$t('collectionCenter.smallDelivery')"
                      :value="3"
                    />
                    <!-- 大件派送 -->
                    <el-option
                      v-show="ruleForm.siteType != 3"
                      :label="$t('collectionCenter.largeDelivery')"
                      :value="4"
                    />
                  </el-select>
                  <template v-else-if="businessTypeLabel">
                    <span style="display: inline-block;width: 100%">
                      <el-button
                        v-for="(label, index) in businessTypeLabel.split('、')"
                        :key="index"
                        type="primary"
                        size="small"
                        style="pointer-events: none;margin-bottom: 2px;color: #424242"
                        plain
                      >
                        {{ label }}
                      </el-button>
                    </span>
                  </template>
                  <span v-else class="nameCode-class">--</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 业务主体 -->
                <el-form-item :label="$t('basicData.BusinessPrincipal')" prop="businessPrincipal">
                  <el-select
                    v-if="isModify"
                    v-model="ruleForm.businessPrincipal"
                    :placeholder="$t('orderDetails.pleaseChoose')"
                    clearable
                    filterable
                    style="width: 100%"
                    @change="changeBusinessPrincipal"
                  >
                    <el-option
                      v-for="(item, index) in businessPrincipalList"
                      :key="index"
                      :label="item.providerCode"
                      :value="item.providerId"
                    />
                  </el-select>
                  <span v-else class="nameCode-class">{{ businessPrincipalLabel }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 服务商渠道： -->
                <el-form-item
                  :label="$t('GlobalSetObj.ServiceProviderChannels')"
                  prop="providerChannelCode"
                >
                  <el-select
                    v-if="isModify"
                    v-model.trim="ruleForm.providerChannelCode"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    clearable
                    filterable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in providerChannelNameList"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                  <span v-else class="nameCode-class">{{ providerChannelLabel }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 所属转运中心 -->
                <el-form-item :label="$t('collectionCenter.owningTransitCenter1')" prop="department">
                  <el-select
                    v-if="isModify"
                    v-model="ruleForm.department"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    clearable
                    filterable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in departmentList"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    />
                  </el-select>
                  <span v-else class="nameCode-class">{{ ruleForm.department || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 联系人 -->
                <el-form-item :label="$t('bank.contact')">
                  <el-input
                    v-if="isModify"
                    v-model.trim="ruleForm.contactsName"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                  />
                  <span v-else class="nameCode-class">{{ ruleForm.contactsName || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 联系电话 -->
                <el-form-item :label="$t('collectionCenter.contactTel')" prop="contactsTel">
                  <el-input
                    v-if="isModify"
                    v-model.trim="ruleForm.contactsTel"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                  />
                  <span v-else class="nameCode-class">{{ ruleForm.contactsTel || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 联系人邮箱 -->
                <el-form-item :label="$t('GlobalSetObj.contactEmail')" prop="mailBox">
                  <el-input
                    v-if="isModify"
                    v-model.trim="ruleForm.mailBox"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                    maxlength="64"
                    show-word-limit
                  />
                  <span v-else class="nameCode-class">{{ ruleForm.mailBox || '--' }}</span>
                </el-form-item>
              </el-col>
            </el-card>
            <el-card shadow="never" class="cardClass">
              <div class="title_top_class"><!-- 网点运营信息 -->
                {{ $t('collectionCenter.branchOperationInfo') }}
              </div>
              <el-col :span="6">
                <!-- 小件揽收范围： -->
                <el-form-item
                  :label="$t('collectionCenter.smallCollectRange')"
                  prop="collectRange"
                >
                  <div v-if="isModify">
                    <el-input v-model="ruleForm.collectRange" style="display: none" />
                    <el-button
                      type="primary"
                      @click="rangeCodeInfoShow($t('collectionCenter.smallCollectRange'), 2, ruleForm.collectRange)"
                    >
                      {{ btnName }}
                    </el-button>
                  </div>
                  <span v-else style="display: flex;align-items: center;width: 60%">
                    <span v-if="ruleForm.collectRange">
                      <el-button
                        type="primary"
                        style="margin-left: 10px;cursor: pointer;flex-shrink: 0"
                        @click="readCodeRange($t('collectionCenter.smallCollectRange'), ruleForm.collectRange)"
                      >
                        {{ btnName }}
                      </el-button>
                    </span>
                    <span v-else style="margin-left: 10px">--</span>
                    <!--                    <span class="nameCode-class" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis" >-->
                    <!--                      {{ ruleForm.collectRange || '&#45;&#45;' }}-->
                    <!--                    </span>-->
                    <!--                    <span-->
                    <!--                      v-show="ruleForm.collectRange"-->
                    <!--                      style="color: #409eff; margin-left: 10px;cursor: pointer;flex-shrink: 0"-->
                    <!--                      @click="readCodeRange($t('collectionCenter.smallCollectRange'), ruleForm.collectRange)"-->
                    <!--                    >{{ $t('collectionCenter.detail') }}</span>-->
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 小件派送范围： -->
                <el-form-item
                  :label="$t('collectionCenter.smallDeliveryRange')"
                  prop="deliveryRange"
                >
                  <div v-if="isModify">
                    <el-input v-model="ruleForm.deliveryRange" style="display: none" />
                    <el-button
                      type="primary"
                      @click="rangeCodeInfoShow($t('collectionCenter.smallDeliveryRange'), 3, ruleForm.deliveryRange)"
                    >
                      {{ btnName }}
                    </el-button>
                  </div>
                  <span v-else style="display: flex;align-items: center;width: 60%">
                    <span v-if="ruleForm.deliveryRange">
                      <el-button
                        type="primary"
                        style="margin-left: 10px;cursor: pointer;flex-shrink: 0"
                        @click="readCodeRange($t('collectionCenter.smallDeliveryRange'), ruleForm.deliveryRange)"
                      >
                        {{ btnName }}
                      </el-button>
                    </span>
                    <span v-else style="margin-left: 10px">--</span>
                    <!--                    <span class="nameCode-class" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis" >-->
                    <!--                      {{ ruleForm.deliveryRange || '&#45;&#45;' }}-->
                    <!--                    </span>-->
                    <!--                    <span-->
                    <!--                      v-show="ruleForm.deliveryRange"-->
                    <!--                      style="color: #409eff; margin-left: 10px;cursor: pointer;flex-shrink: 0"-->
                    <!--                      @click="readCodeRange($t('collectionCenter.smallDeliveryRange'), ruleForm.deliveryRange)"-->
                    <!--                    >{{ $t('collectionCenter.detail') }}</span>-->
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!--      大件派送范围          -->
                <el-form-item
                  :label="$t('collectionCenter.largeDeliveryRange')"
                  prop="bulkyDeliverZipCode"
                >
                  <div v-if="isModify">
                    <el-input v-model="ruleForm.bulkyDeliverZipCode" style="display: none" />
                    <el-button
                      type="primary"
                      @click="rangeCodeInfoShow($t('collectionCenter.largeDeliveryRange'), 4, ruleForm.bulkyDeliverZipCode)"
                    >
                      {{ btnName }}
                    </el-button>
                  </div>
                  <span v-else style="display: flex;align-items: center;width: 60%">
                    <span v-if="ruleForm.bulkyDeliverZipCode">
                      <el-button
                        type="primary"
                        style="margin-left: 10px;cursor: pointer;flex-shrink: 0"
                        @click="readCodeRange($t('collectionCenter.largeDeliveryRange'), ruleForm.bulkyDeliverZipCode)"
                      >
                        {{ btnName }}
                      </el-button>
                    </span>
                    <span v-else style="margin-left: 10px">--</span>
                    <!--                    <span class="nameCode-class" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis" >-->
                    <!--                      {{ ruleForm.bulkyDeliverZipCode || '&#45;&#45;' }}-->
                    <!--                    </span>-->
                    <!--                    <span-->
                    <!--                      v-show="ruleForm.bulkyDeliverZipCode"-->
                    <!--                      style="color: #409eff; margin-left: 10px;cursor: pointer;flex-shrink: 0"-->
                    <!--                      @click="readCodeRange($t('collectionCenter.largeDeliveryRange'), ruleForm.bulkyDeliverZipCode)"-->
                    <!--                    >{{ $t('collectionCenter.detail') }}</span>-->
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!--  营业时间  -->
                <el-form-item :label="$t('base.openingHours')">
                  <el-button
                    v-if="isModify" type="primary"
                    style="cursor: pointer;flex-shrink: 0"
                    @click="rangeInfoShow(ruleForm.siteBusinessTimeData)"
                  >
                    {{ btnName }}
                  </el-button>
                  <span v-else style="display: flex;align-items: center;width: 100%">
                    <el-button
                      v-if="ruleForm.siteBusinessTimeData && ruleForm.siteBusinessTimeData.length > 0"
                      type="primary" style="flex-shrink: 0"
                      @click="checkTimeFn(ruleForm.siteBusinessTimeData)"
                    >
                      {{ btnName }}
                    </el-button>
                    <span v-else style="margin-left: 10px">--</span>
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 是否启用 -->
                <el-form-item :label="$t('collectionCenter.ifUse')" prop="siteStatus">
                  <el-select
                    v-if="isModify"
                    v-model="ruleForm.siteStatus"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    clearable
                    filterable
                    style="width: 100%"
                    @change="siteStatusChange()"
                  >
                    <el-option :label="$t('collectionCenter.enable')" :value="1" /><!-- 启用 -->
                    <el-option :label="$t('collectionCenter.Disable')" :value="0" /><!-- 停用 -->
                  </el-select>
                  <span v-else class="nameCode-class">{{ siteStatusLabel }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 是否已签署合同 -->
                <el-form-item :label="$t('collectionCenter.contractSigned')" prop="contractSigned">
                  <el-select
                    v-if="isModify"
                    v-model="ruleForm.contractSigned"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    clearable
                    filterable
                    style="width: 100%"
                  >
                    <el-option :label="$t('GlobalSetObj.yes')" :value="1" />
                    <el-option :label="$t('GlobalSetObj.No')" :value="0" />
                  </el-select>
                  <span v-else class="nameCode-class">{{ contractSignedLabel }}</span>
                </el-form-item>
              </el-col>
            </el-card>
            <el-card shadow="never" class="cardClass">
              <div class="title_top_class"><!-- 网点地址信息 -->
                {{ $t('collectionCenter.branchAddressInfo') }}
              </div>
              <el-col :span="8">
                <!-- 网点邮编 -->
                <el-form-item :label="$t('collectionCenter.zipCodeTitle')" prop="zipCode">
                  <el-input
                    v-if="isModify"
                    v-model.trim="ruleForm.zipCode"
                    :placeholder="$t('collectionCenter.input8ZipCode')"
                    clearable
                    maxlength="8"
                    style="width: 100%"
                  />
                  <span v-else class="nameCode-class">{{ ruleForm.zipCode || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="[2, 3].includes(ruleForm.siteType)" :span="8">
                <!-- 所属大区 -->
                <el-form-item :label="$t('orderCenterCont.BelongsToTheRegion')" prop="regionId">
                  <el-select
                    v-if="isModify"
                    v-model="ruleForm.regionId"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    clearable
                    filterable
                    style="width: 100%"
                    @change="regionChangeOption"
                  >
                    <el-option
                      v-for="item in regionList"
                      :key="item.id"
                      :label="item.zhName + '（' + item.puName + '）'"
                      :value="item.id"
                    />
                  </el-select>
                  <span v-else class="nameCode-class">{{ regionLabel }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 网点所属州 -->
                <el-form-item :label="$t('collectionCenter.stateSite')" prop="state">
                  <el-select
                    v-if="isModify"
                    v-model="ruleForm.state"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    clearable
                    filterable
                    size="small"
                    style="width: 100%"
                    @change="stateChangeOption"
                  >
                    <el-option
                      v-for="item in StateList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.label"
                    />
                  </el-select>
                  <span v-else class="nameCode-class">{{ ruleForm.state || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--   城市  -->
                <el-form-item :label="$t('collectionCenter.city')" prop="city">
                  <el-select
                    v-if="isModify"
                    v-model="ruleForm.city"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    clearable filterable size="small"
                    style="width: 100%"
                    remote reserve-keyword
                    :remote-method="getState"
                    @clear="stateChangeOption"
                  >
                    <el-option
                      v-for="item in cityList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    />
                  </el-select>
                  <span v-else class="nameCode-class">{{ ruleForm.city || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--  区域  -->
                <el-form-item :label="$t('collectionCenter.area')" prop="area">
                  <el-input
                    v-if="isModify"
                    v-model.trim="ruleForm.area"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                    maxlength="50"
                  />
                  <span v-else class="nameCode-class">{{ ruleForm.area || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--  街道 -->
                <el-form-item :label="$t('newOrder.Street')" prop="street">
                  <el-input
                    v-if="isModify"
                    v-model.trim="ruleForm.street"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                    maxlength="80"
                  />
                  <span v-else class="nameCode-class">{{ ruleForm.street || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--  门牌号 -->
                <el-form-item :label="$t('orderCenterCont.HouseNumber')" prop="houseNumber">
                  <el-input
                    v-if="isModify"
                    v-model.trim="ruleForm.houseNumber"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                    maxlength="14"
                  />
                  <span v-else class="nameCode-class">{{ ruleForm.houseNumber || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <!--  地址补充  -->
                <el-form-item :label="$t('placeOrder.addressComplement')" prop="address">
                  <el-input
                    v-if="isModify"
                    v-model.trim="ruleForm.address"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                    maxlength="500"
                    show-word-limit
                  />
                  <span v-else class="nameCode-class">{{ ruleForm.address || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--  经度 -->
                <el-form-item
                  :label="$t('orderCenterCont.longitude')" prop="longitude"
                >
                  <el-input
                    v-if="isModify"
                    v-model.trim="ruleForm.longitude"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                  />
                  <span v-else class="nameCode-class">{{ ruleForm.longitude || '--' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--  纬度  -->
                <el-form-item
                  :label="$t('orderCenterCont.latitude')" prop="latitude"
                >
                  <el-input
                    v-if="isModify"
                    v-model.trim="ruleForm.latitude"
                    :placeholder="$t('GlobalSetObj.pleaseInput')"
                    clearable
                  />
                  <span v-else class="nameCode-class">{{ ruleForm.latitude || '--' }}</span>
                </el-form-item>
              </el-col>
            </el-card>
            <el-col v-if="isModify" :span="15" style="float: right">
              <div style="float: right; height: 60px; margin-top: 20px;">
                <el-button
                  @click.stop="resetClick"
                >{{ $t('collectionCenter.empty') }}
                </el-button><!-- 清空 -->
                <el-button
                  style="margin-left: 20px;margin-right: 20px" @click="cancelForm"
                >{{ $t('GlobalSetObj.Cancelar') }}
                </el-button>
                <el-button
                  type="primary" @click="saveForm"
                >{{ $t('GlobalSetObj.Salve') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-drawer>
    <rangeInfo ref="rangeInfoRef" :rule-form="ruleForm" @childrenData="rangeInfoData" />
    <siteBusinessTime ref="siteBusinessTimeRef" @getDate="timeDate" />
  </div>
</template>

<script>
import {
  getProviderChannel,
  getTransitCenter,
  providerList,
  siteAdd,
  siteBusinessTimeGetAllBusinessWeek,
  siteEdit
} from '@/api/lanshou';
import { getLgAreaListData, selectCity, regionQueryList } from '@/api/orderApi';
import { cloneDeep } from 'lodash-es';
import { checkCode, phoneNumberCode } from '@/utils/validate';
import { MessageBox } from 'element-ui';

const paramsObj = {
  code: '', // 网点编号
  name: '', // 网点名称
  zipCode: '', // 邮编
  state: '', // 网点所属州
  city: '', // 城市
  area: '', // 区
  street: '', // 街道/地址
  address: '', // 网点地址
  siteType: '', // 操作类型 0：揽收 1：退件'
  department: '', // 所属转运中心
  siteStatus: 0, // 网点状态 0：未启用 1启用
  contactsName: '', // 联系人
  contactsTel: '', // 负责人联系方式
  deliveryRange: '', // 小件派送范围
  collectRange: '', // 揽收范围
  bulkyDeliverZipCode: '', // 大件派送范围
  businessModel: '', // 经营模式
  longitude: '', // 经度
  latitude: '', // 纬度
  businessPrincipal: '', // 业务主体
  businessType: [], // 业务类型
  mailBox: '',
  providerChannelCode: '', // 服务商渠道
  siteBusinessTimeData: [], // 营业时间
  regionId: null,
  houseNumber: '',
  contractSigned: '' // 是否已签署合同
};
export default {
  components: {
    rangeInfo: () => import('./rangeInfo.vue'),
    siteBusinessTime: () => import('./openingHours.vue')
  },
  data() {
    const longitudeValidator = (rule, value, callback) => {
      if (!value && value !== 0) {
        return callback(new Error(this.$t('collectionCenter.notNull')));
      }
      const reg = /^[-+]?(0?\d{1,2}(?:\.\d{1,7})?|1[0-7]\d(?:\.\d{1,7})?|180(?:\.0{1,7})?)$/;
      if (!reg.test(value) || value < -180 || value > 180) {
        return callback(new Error(this.$t('collectionCenter.longitudeInputError'))); // 请输入正确的经度
      } else {
        return callback();
      }
    };
    const latitudeValidator = (rule, value, callback) => {
      if (!value && value !== 0) {
        return callback(new Error(this.$t('collectionCenter.notNull')));
      }
      const reg = /^[-+]?([0-8]?\d(?:\.\d{1,7})?|90(?:\.0{1,7})?)$/;
      if (!reg.test(value) || value < -90 || value > 90) {
        return callback(new Error(this.$t('collectionCenter.latitudeInputError'))); // 请输入正确的纬度
      } else {
        return callback();
      }
    };
    return {
      isModify: false,
      longitudeValidator,
      latitudeValidator,
      // 业务主体选择影响经营模式选项
      isAll: 0, // 1 自营,  2 加盟  3 独家
      // 是否格式化成巴西时间
      isTormat: false,
      regionList: [],
      newSiteDrawer: false,
      titleName: this.$t('collectionCenter.addNewBranch'), // '新增网点'
      btnName: '',
      ruleForm: cloneDeep(paramsObj),
      rules: {
        code: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (!checkCode(value)) {
                // '请填写长度6至30位的字母+数字组合'
                return callback(new Error(this.$t('collectionCenter.inputLong6')));
              } else {
                callback();
              }
            }
          }
        ],
        name: [
          // 长度不能少于4位，不能大于100位
          {
            required: true,
            min: 4,
            max: 100,
            message: this.$t('collectionCenter.long4to100'),
            trigger: ['blur', 'change']
          }
        ],
        siteType: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        businessType: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        businessPrincipal: [
          {
            required: true,
            message: this.$t('placeOrder.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        providerChannelCode: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        regionId: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (this.ruleForm.siteType === 2 && !value) {
                callback(new Error(this.$t('orderCenterCont.chooseRegion')));
              } else {
                callback();
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        department: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        contactsTel: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (value && !phoneNumberCode(value)) {
                return callback(new Error(this.$t('collectionCenter.brazilPhoneRestrict'))); // 长度不低于10位，允许包含+-空格等特殊字符
              } else {
                callback();
              }
            }
          }
        ],
        mailBox: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (value && value.length > 64) {
                return callback(new Error(this.$t('placeOrder.emailNotFormat')));
              }
              const reg = /^([a-zA-Z0-9_-])+\.(com)+((.br)?)$/;
              const val = value.split('@');
              if (!reg.test(val[1])) {
                return callback(new Error(this.$t('placeOrder.emailNotFormat')));
              } else {
                callback();
              }
            }
          }
        ],
        siteStatus: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        contractSigned: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        zipCode: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^([0-9]{8})$/;
              if (!reg.test(value)) {
                // '请输入8位邮编'
                return callback(new Error(this.$t('collectionCenter.input8ZipCode')));
              } else {
                callback();
              }
            }
          }
        ],
        state: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        city: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        street: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        houseNumber: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        longitude: [
          {
            required: true,
            validator: longitudeValidator,
            trigger: ['blur', 'change']
          }
        ],
        latitude: [
          {
            required: true,
            validator: latitudeValidator,
            trigger: ['blur', 'change']
          }
        ],
        area: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        businessModel: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        collectRange: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        deliveryRange: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        bulkyDeliverZipCode: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ]
      },
      providerChannelNameList: [],
      departmentList: [], // 转运中心
      StateList: [],
      cityList: [],
      businessPrincipalList: [] // 业务主体
    };
  },
  computed: {
    businessModelLabel() {
      if (!this.ruleForm.businessModel) return '--';
      const businessModelMap = {
        1: this.$t('collectionCenter.directSales'), // 自营
        2: this.$t('collectionCenter.joinSales'), // 加盟
        3: this.$t('collectionCenter.exclusive') // 独家
      };
      return businessModelMap[this.ruleForm.businessModel];
    },
    siteTypeLabel() {
      if (this.ruleForm.siteType) {
        const siteTypeMap = {
          1: this.$t('collectionCenter.hut'), // 小屋
          2: this.$t('collectionCenter.dot'), // 网点
          3: this.$t('collectionCenter.transferCenter'), // 转运中心
          4: this.$t('collectionCenter.headOffice') // 总部
        };
        return siteTypeMap[this.ruleForm.siteType];
      } else {
        return '--';
      }
    },
    businessTypeLabel() {
      if (!this.ruleForm.businessType || !this.ruleForm.businessType.length) {
        return '';
      }
      const businessTypeMap = {
        1: this.$t('collectionCenter.turnTransport'), // 转运
        2: this.$t('collectionCenter.smallCollect'), // 小件揽收
        3: this.$t('collectionCenter.smallDelivery'), // 小件派送
        4: this.$t('collectionCenter.largeDelivery') // 大件派送
      };
      if (Array.isArray(this.ruleForm.businessType)) {
        return this.ruleForm.businessType
          .map(type => businessTypeMap[type])
          .filter(label => label)
          .join('、');
      }
      // 可能是字符串
      if (typeof this.ruleForm.businessType === 'string') {
        return this.ruleForm.businessType
          .split(',')
          .map(type => businessTypeMap[parseInt(type)])
          .filter(label => label)
          .join('、');
      }
      return '';
    },
    businessPrincipalLabel() {
      if (!this.ruleForm.businessPrincipal) return '--';
      const principal = this.businessPrincipalList.find(item => item.providerId === this.ruleForm.businessPrincipal);
      return principal ? principal.providerCode : '--';
    },
    providerChannelLabel() {
      if (!this.ruleForm.providerChannelCode) return '--';
      const channel = this.providerChannelNameList.find(item => item.code === this.ruleForm.providerChannelCode);
      return channel ? channel.name : '--';
    },
    regionLabel() {
      if (!this.ruleForm.regionId) return '--';
      const region = this.regionList.find(item => item.id === this.ruleForm.regionId);
      return region ? `${region.zhName}（${region.puName}）` : '--';
    },
    siteStatusLabel() {
      const statusMap = {
        1: this.$t('collectionCenter.enable'),
        0: this.$t('collectionCenter.disabledInactive'),
        2: this.$t('collectionCenter.disabledSuspended'),
        3: this.$t('collectionCenter.disabledStandby')
      };
      return this.ruleForm.siteStatus !== undefined && this.ruleForm.siteStatus !== null
        ? statusMap[this.ruleForm.siteStatus] || '--'
        : '--';
    },
    contractSignedLabel() {
      const contractMap = {
        1: this.$t('GlobalSetObj.yes'),
        0: this.$t('GlobalSetObj.No')
      };
      return this.ruleForm.contractSigned !== undefined && this.ruleForm.contractSigned !== null
        ? contractMap[this.ruleForm.contractSigned] || '--'
        : '--';
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.isAll = 0;
    this.isModify = false;
    this.getAddressState();
    this.getRegion();
    this.getProviderList();
    this.getDepartment();
    this.getSiteWeekList();
  },
  methods: {
    // 启用状态变化
    siteStatusChange() {
      this.changeBusinessType();
    },
    regionChangeOption() {
      this.ruleForm.state = '';
      this.ruleForm.city = '';
      const newVal = this.ruleForm.regionId;
      if (newVal && this.regionList.length > 0) {
        const selectedRegion = this.regionList.find((item) => item.id === newVal);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          const allStates = [];
          selectedRegion.sites.forEach(state => {
            // 避免重复添加
            if (!allStates.some(s => s.label === state.state)) {
              allStates.push({
                id: state.id,
                label: state.state
              });
            }
          });
          this.StateList = allStates;
        }
      } else {
        this.StateList = [];
        this.getAddressState();
      }
    },
    changeBusinessModel() {
      // 切换经营模式清空网点类型
      this.$forceUpdate();
      if (this.ruleForm.businessModel === 2) {
        this.ruleForm.siteType = '';
        this.$nextTick(() => {
          this.$refs['addForm'].clearValidate('siteType');
        });
      }
      this.changeSiteType(this.ruleForm.siteType);
    },
    useSiteType(val) {
      /**
       * 产品要求：
       * 1、当网点类型为总部则揽收范围、派送范围非必填
       * 2、当业务类型为揽收时，派送范围非必填
       * 3、当业务类型中含派送时，派送范围必填且校验不允许重复————小件派送
       * 4、当业务类型中含派送时，派送范围必填且校验不允许重复————大件派送
       */
      // 网点类型为转运中心(3)或总部(4)时，所有范围字段都非必填
      if ([3, 4].includes(val)) {
        this.setRangeRequired(false, false, false);
      } else if ([1, 2].includes(val)) {
        // 网点类型为小屋(1)或网点(2)时，所有范围字段都必填
        this.setRangeRequired(true, true, true);
      } else {
        // 默认情况，根据业务类型来设定
        this.updateRangeByBusinessType();
      }
    },
    changeSiteType(val) {
      this.ruleForm.businessType = [];
      this.useSiteType(val);
    },
    /**
     * 最终理解：
     * 当网点类型为网点(2)或小屋(1)时，所有范围字段都必须填写；
     * 当网点类型为转运中心(3)或总部(4)时，所有范围字段都不是必填项；
     * 业务类型： 小件揽收：2       小件派送：3       大件派送：4
     * 在业务类型有值且网点类型不是转运中心或总部的情况下，应按照业务类型决定必填项
     */
    changeBusinessType() {
      /**
       * 网点跟小屋时，选哪个哪个必填
       * 需考虑为空的情况
       */
      this.$refs['addForm'].clearValidate();
      console.log(this.ruleForm.siteStatus, '===this.ruleForm.siteStatus');
      if (this.ruleForm.siteStatus === 0) {
        this.setRangeRequired(false, false, false);
        return;
      }
      // 若网点类型为转运中心或总部，则不做处理
      if ([3, 4].includes(this.ruleForm.siteType)) return;

      // 更新范围字段的必填状态
      this.updateRangeByBusinessType();
    },
    // 设置范围字段的必填状态
    setRangeRequired(collectRequired, deliveryRequired, bulkyRequired) {
      this.rules.collectRange[0].required = collectRequired;
      this.rules.deliveryRange[0].required = deliveryRequired;
      this.rules.bulkyDeliverZipCode[0].required = bulkyRequired;
    },
    // 根据业务类型更新范围字段的必填状态
    updateRangeByBusinessType() {
      const businessTypes = this.ruleForm.businessType || [];
      const isSmallPackageCollection = businessTypes.includes(2);
      const isSmallPackageDelivery = businessTypes.includes(3);
      const isLargePackageDelivery = businessTypes.includes(4);
      this.setRangeRequired(
        isSmallPackageCollection,
        isSmallPackageDelivery,
        isLargePackageDelivery
      );
    },

    // 添加
    addSiteData() {
      this.isModify = true;
      this.newSiteDrawer = true;
      this.titleName = this.$t('collectionCenter.addNewBranch'); // '新增网点'
      this.btnName = this.$t('GlobalSetObj.add');
    },
    // 查看
    seeSiteData(data) {
      this.isModify = false;
      this.titleName = this.$t('collectionCenter.branchInformation'); // '网点信息'
      this.btnName = this.$t('GlobalSetObj.View');
      this.shared(data);
      this.$nextTick(() => {
        if (this.$refs['addForm']) {
          this.$refs['addForm'].clearValidate();
        }
      });
    },
    editSiteData(data) {
      this.isModify = true;
      this.titleName = this.$t('GlobalSetObj.EditingDot'); // '编辑网点'
      this.btnName = this.$t('GlobalSetObj.edit');
      this.shared(data);
    },
    shared(data) {
      this.newSiteDrawer = true;
      this.ruleForm = data;
      this.getProviderChannelList(data.businessPrincipal);
      this.getRegion();
      this.getState();
      this.useSiteType(data.siteType);
      this.$nextTick(() => {
        this.changeBusinessType();
      });
    },
    // 获取范围数据
    rangeInfoData(val, type) {
      if (type === 2) { this.ruleForm.collectRange = val; }
      if (type === 3) { this.ruleForm.deliveryRange = val; }
      if (type === 4) { this.ruleForm.bulkyDeliverZipCode = val; }
    },
    // 打开邮编填写窗口
    rangeCodeInfoShow(val, type, rangeVal) {
      this.$refs.rangeInfoRef.showDialog(val, type, rangeVal);
    },
    // 打开查看邮编窗口
    readCodeRange(title, rangeVal) {
      this.$refs.rangeInfoRef.readDialog(title, rangeVal);
    },
    // 打开时间范围填写
    rangeInfoShow(val) {
      this.$refs.siteBusinessTimeRef.showDialog(val);
    },
    checkTimeFn(val) {
      this.$refs.siteBusinessTimeRef.readDialog(val);
    },
    // 获取时间
    timeDate(val) {
      this.ruleForm.siteBusinessTimeData = val;
    },
    /**
     * @description: 获取营业时间字典列表
     */
    getSiteWeekList() {
      siteBusinessTimeGetAllBusinessWeek()
        .then((res) => {
          if (res.code === 200) {
            const weekListObj = {};
            res.data.forEach((item) => {
              weekListObj[item.dictId] = item.dictDescribe;
            });
            this.weekListObj = weekListObj;
          }
        })
        .catch({});
    },
    // 取消
    cancelForm() {
      this.newSiteDrawer = false;
      this.ruleForm = cloneDeep(paramsObj);
      setTimeout(() => {
        this.$refs['addForm'].clearValidate();
      }, 0);
    },
    // 提交保存
    async saveForm() {
      const valid = await this.$refs['addForm'].validate();
      if (!valid) {
        setTimeout(() => {
          if (document.querySelector('.el-form-item__error')) {
            // eslint-disable-next-line no-unused-expressions
            document.querySelectorAll('.el-form-item__error')[0]?.parentNode?.scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            });
          }
        }, 1);
      } else if (this.ruleForm.siteType === 2 && !this.ruleForm.regionId) {
        this.$message.warning(this.$t('orderCenterCont.chooseRegion')); // 请选择大区
      } else {
        MessageBox.confirm(
          this.$t('collectionCenter.isSave'),
          this.$t('collectionCenter.tips'),
          {
            confirmButtonText: this.$t('collectionCenter.Confirm'),
            center: true,
            showClose: false
          }
        )
          .then((arr) => {
            const ruleForm = cloneDeep(this.ruleForm);
            if (ruleForm.siteType !== 2 && ruleForm.siteType !== 3) {
              this.ruleForm.regionId = null;
              ruleForm.regionId = null;
            }
            ruleForm.businessType = ruleForm.businessType.toString();
            if (this.titleName === this.$t('collectionCenter.addNewBranch')) {
              delete ruleForm.id;
              siteAdd(ruleForm).then(res => {
                if (res.code === 200) {
                  this.$message({
                    message: this.$t('collectionCenter.SaveSuccessfully'), // '保存成功'
                    type: 'success'
                  });
                  this.newSiteDrawer = false;
                  this.$refs['addForm'].clearValidate();
                  this.$emit('reSearch');
                }
              });
            }
            if (this.titleName === this.$t('GlobalSetObj.EditingDot')) {
              siteEdit(ruleForm).then(res => {
                if (res.code === 200) {
                  this.$message({
                    message: this.$t('collectionCenter.SaveSuccessfully'), // '保存成功'
                    type: 'success'
                  });
                  this.newSiteDrawer = false;
                  this.$refs['addForm'].clearValidate();
                  this.$emit('reSearch');
                }
              });
            }
          })
          .catch(() => {});
      }
    },
    // 清空
    resetClick() {
      const editId = this.ruleForm.id;
      this.ruleForm = cloneDeep(paramsObj);
      this.ruleForm.id = editId;
      setTimeout(() => {
        this.$refs['addForm'].clearValidate();
      }, 0);
      this.isAll = 0;
      this.getRegion();
      this.getAddressState();
      this.stateChangeOption();
    },
    getAddressState() {
      // level 0 州    1 城市   2 地区
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: item.nameEn
            };
          });
        }
      });
    },
    stateChangeOption() {
      this.ruleForm.city = '';
      this.getState();
    },
    getState(city = '') {
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          id: null,
          name: city,
          names: [this.ruleForm.state]
        }
      };
      selectCity(params, false).then((res) => {
        if (res.code === 200) {
          this.cityList = res.data.records;
        }
      });
    },
    getProviderList() {
      providerList().then((res) => {
        this.businessPrincipalList = [];
        if (res.code === 200) {
          res.data.forEach((arr) => {
            this.businessPrincipalList.push({
              providerCode: arr.providerBody,
              providerId: arr.id
            });
          });
        }
      });
    },
    // 业务主体
    changeBusinessPrincipal(val) {
      this.ruleForm.providerChannelCode = '';
      this.getProviderChannelList(val);
    },
    getProviderChannelList(businessPrincipal) {
      if (businessPrincipal) {
        this.providerChannelNameList = [];
        getProviderChannel(businessPrincipal).then((res) => {
          if (res.code === 200) {
            // 经营模式
            if (res.data.providerType === 1) {
              this.isAll = 1;
              this.ruleForm.businessModel = 1;
            }
            if (res.data.providerType === 2 || res.data.providerType === 3) {
              this.isAll = 2;
              this.ruleForm.businessModel = 2;
            }
            if (!res.data.providerType) {
              // 展示直营和加盟
              this.isAll = 0;
            }

            // 服务商渠道
            const channelList = [];
            if (res.data.providerChannelInfoList) {
              res.data.providerChannelInfoList.forEach((list) => {
                channelList.push({
                  name: list.providerChannelName,
                  code: list.providerChannelCode
                });
              });
              this.providerChannelNameList = channelList;
            }
          }
        });
      } else {
        this.isAll = 0;
      }
    },
    // 大区
    getRegion() {
      regionQueryList('').then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    // 转运中心
    getDepartment() {
      getTransitCenter().then((res) => {
        if (res.code === 200) {
          this.departmentList = res.data;
        }
      });
    }
  }
};
</script>

<style scoped>
.title_top_class {
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  color:#429efe;
  margin-bottom: 20px;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield !important;
}
.nameCode-class {
  font-size: 15px; color: #424242; display: inline-block; width: 100%;
  text-indent: 10px;
}
.demo-ruleForm ::v-deep .el-form-item__label {
  font-size: 15px !important;
  display: block;
  width: 100%;
  text-align: left;
}
.codeClick { cursor: pointer; }
.cardClass ::v-deep .el-card__body {
  padding-bottom: 10px;box-sizing: border-box;margin-bottom: 10px;
  display: flex;justify-content: flex-start;flex-wrap: wrap;
}
</style>
